import { render, staticRenderFns } from "./StockIQ.vue?vue&type=template&id=073937de"
import script from "./StockIQ.vue?vue&type=script&lang=js"
export * from "./StockIQ.vue?vue&type=script&lang=js"
import style0 from "./StockIQ.vue?vue&type=style&index=0&id=073937de&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports